module.exports = __webpack_public_path__ + "img/app.5b6660f2.png";